import React, { useEffect, useState } from 'react';
import { useParams, Link, useNavigate } from 'react-router-dom';
import axios from '../axios';
import {
    Container,
    DetailsBtns,
    DetailsHeading,
    Flex,
    H1,
    SmallSpacing,
    Tr, Table, Th, Td, ListHeading, CreateBtn, H3, InlineLink, ProfileTable, MediumSpacing
} from "../../styles";
import useAdminStatus from "../hooks/useAdminStatus";

const ClassDetail = () => {
    const { id } = useParams();
    const navigate = useNavigate();
    const [classDetail, setClassDetail] = useState(null);
    const { isAdmin, userType } = useAdminStatus();

    useEffect(() => {
        axios.get(`/class/${id}/`)
            .then(response => {
                setClassDetail(response.data);
            })
            .catch(error => console.error("There was an error fetching the class data!", error));
    }, [id]);

    if (!classDetail) {
        return <div>Loading...</div>;
    }

    const handleDelete = (id) => {
        if (window.confirm("Are you sure you want to delete this class?")) {
            axios.delete(`/class/delete/${id}/`)
                .then(() => {
                    navigate('/classes');
                })
                .catch(error => {
                    console.error("There was an error deleting the class!", error);
                });
        }
    };

    const handleEnrollmentDelete = (id) => {
        if (window.confirm("Are you sure you want to delete this enrollment?")) {
            axios.delete(`/student_enrollment/delete/${id}/`)
                .then(() => {
                    setClassDetail(prevState => ({
                        ...prevState,
                        student_enrollments: prevState.student_enrollments.filter(enrollment => enrollment.id !== id)
                    }));
                })
                .catch(error => {
                    console.error("There was an error deleting the enrollment!", error);
                });
        }
    };

    const getStudentDetails = (studentId) => {
        return classDetail.students.find(student => student.student_id === studentId);
    };

    return (
        <Container>
            <ListHeading>
                <H1>{classDetail.course_details.name}</H1>
                {isAdmin && (
                    <Flex>
                        <InlineLink>
                            <Link to={`/class/update/${classDetail.id}`}>Update Class</Link>
                        </InlineLink>
                        <SmallSpacing />
                        <InlineLink>
                            <Link to="#" onClick={() => handleDelete(classDetail.id)}>Delete Class</Link>
                        </InlineLink>
                    </Flex>
                )}
            </ListHeading>
            <ProfileTable>
                <Tr>
                    <Td>Class Number</Td>
                    <Td>{classDetail.number}</Td>
                </Tr>
                <Tr>
                    <Td>Semester</Td>
                    <Td>{classDetail.semester_details.semester}</Td>
                </Tr>
                <Tr>
                    <Td>Year</Td>
                    <Td>{classDetail.semester_details.year}</Td>
                </Tr>
                <Tr>
                    <Td>Lecturer</Td>
                    <Td>{classDetail.lecturer_details.first_name} {classDetail.lecturer_details.last_name}</Td>
                </Tr>
            </ProfileTable>
            <MediumSpacing />
            {(isAdmin || userType === 'lecturer') && (
                <>
                    <ListHeading>
                        <H3>Students Enrolled:</H3>
                         {isAdmin && (
                        <CreateBtn>
                            <Link to="/student_enrollment/create">Add Student</Link>
                        </CreateBtn>)}


                    </ListHeading>
                    {classDetail.student_enrollments.length > 0 ? (

                        <Table>
                            <Tr>
                                <Th>Student Name</Th>
                                <Th>Grade</Th>
                                <DetailsHeading>Update Grade</DetailsHeading>
                                 {isAdmin && (
                                <DetailsHeading>Details</DetailsHeading>)}
                            </Tr>
                            {classDetail.student_enrollments.map(enrollment => {
                                const student = getStudentDetails(enrollment.student);
                                return (
                                    <Tr key={enrollment.id}>
                                        <Td>{student ? `${student.first_name} ${student.last_name}` : 'N/A'}</Td>
                                        <Td>{enrollment.grade || '-'}</Td>
                                        <DetailsBtns>
                                            <Link to={`/student_enrollment/update_grade/${enrollment.id}`}>Update</Link>
                                        </DetailsBtns>
                                        {isAdmin && (
                                        <DetailsBtns>
                                            <Flex>
                                                <Link to={`/student/${enrollment.student}`}>View</Link>
                                                <SmallSpacing />
                                                {isAdmin && (
                                                    <>
                                                        <Link to={`/student_enrollment/${enrollment.id}`}>Update</Link>
                                                        <SmallSpacing />
                                                        <Link to="#" onClick={() => handleEnrollmentDelete(enrollment.id)}>Delete</Link>
                                                    </>
                                                )}
                                            </Flex>
                                        </DetailsBtns>

                                        )}
                                    </Tr>
                                );
                            })}
                        </Table>
                    ) : (
                        <p>No students enrolled</p>
                    )}
                </>
            )}
        </Container>
    );
};

export default ClassDetail;
